class WelcomeOfferBuilderFooter extends HTMLElement {
  constructor() {
    super();
    this.offerInCart = false;
    this.selectedItems = [];
    this.onAddToCartClick = this.onAddToCartClick.bind(this);
    this.onRemoveClick = this.onRemoveClick.bind(this);
    this.freeGiftVariantId = 42430018519121;

    this.handleCartUpdate = this.handleCartUpdate.bind(this);

    // Config: Set offer string based on version
    const version = this.getAttribute('data-offer-version') || 'original';
    this.offerVersion = version;
    const offerStringMap = {
      original: 'welcome-offer-2025',
      winter2025: 'winter-welcome-offer-2025',
      feb2026: 'welcome-offer-feb-2026',
    };
    this.offerString = offerStringMap[version] || offerStringMap['original'];
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.selectedContainer = this.querySelector('.welcome-offer-builder__footer--selected_items');
    this.addToCartButton = this.querySelector('[data-action="add-to-cart"]');

    this.addToCartButton?.addEventListener('click', this.onAddToCartClick);
    this.selectedContainer?.addEventListener('click', this.onRemoveClick);

    this.updateUI();

    window.addEventListener('cartUpdateEnriched', this.handleCartUpdate);

    const initial = window.__abc?.ShopifyCartData;
    if (initial && initial.cart) {
      this.handleCartUpdate({ detail: initial });
    }
  }

  disconnectedCallback() {
    this.addToCartButton?.removeEventListener('click', this.onAddToCartClick);
    this.selectedContainer?.removeEventListener('click', this.onRemoveClick);

    window.removeEventListener('cartUpdateEnriched', this.handleCartUpdate);
    this.initialized = false;
  }

  handleCartUpdate(event) {
    const enriched = event.detail || {};
    this.cart = enriched.cart || {};
    // look for any line-item with properties._offer matching the configured offer string
    this.offerInCart =
      Array.isArray(this.cart.items) &&
      this.cart.items.some(
        (item) => item.properties != null && item.properties._offer === this.offerString
      );
    //console.log('offerInCart', this.offerInCart);

    this.updateUI();
  }

  updateProperties({ selectedItems = [] } = {}) {
    this.selectedItems = selectedItems;
    // console.log('selectedItems', this.selectedItems);
    this.updateUI();
  }

  updateUI() {
    if (!this.selectedContainer) return;

    // 1) remove any old dynamic wrappers
    this.selectedContainer.querySelectorAll('[data-dynamic="true"]').forEach((el) => el.remove());

    // 2) build flat list of selected items, up to 2
    const totalSlots = 2;
    const flatItems = this.selectedItems
      .flatMap((item) => Array(item.quantity).fill(item))
      .slice(0, totalSlots);

    // 3) grab your two static placeholders
    const placeholders = Array.from(this.selectedContainer.querySelectorAll('.placeholder-item'));

    placeholders.forEach((ph, i) => {
      if (i < flatItems.length) {
        const item = flatItems[i];

        // hide the placeholder completely
        ph.style.display = 'none';

        // build the wrapper
        const wrapper = document.createElement('div');
        wrapper.className = 'welcome-offer-builder__selected_item';
        wrapper.setAttribute('data-dynamic', 'true');
        wrapper.setAttribute('data-action', 'remove');
        wrapper.setAttribute('data-product-id', item.productId);
        wrapper.setAttribute('data-variant-id', item.variantId);
        wrapper.style.cursor = 'pointer';

        // image
        const imgWrap = document.createElement('div');
        imgWrap.className = 'welcome-offer-builder__selected_item--image';
        imgWrap.style.backgroundColor = item.productColor;
        const img = document.createElement('img');
        img.src = item.productImage;
        img.alt = item.productTitle;
        imgWrap.appendChild(img);

        // details
        const details = document.createElement('div');
        details.className = 'welcome-offer-builder__selected_item--details';
        const titleEl = document.createElement('h4');
        titleEl.className = 'welcome-offer-builder__selected_item--title';
        titleEl.textContent = item.productTitle;
        details.appendChild(titleEl);

        // remove icon
        const removeIcon = document.createElement('span');
        removeIcon.className = 'select_item_action welcome-offer-builder__remove-icon';
        removeIcon.setAttribute('aria-hidden', 'true');
        removeIcon.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8" viewBox="0 0 9 8" fill="none">
          <path d="M7.71137 0.356079L0.77832 7.2888" stroke="white"/>
          <path d="M7.71137 7.28821L0.77832 0.355469" stroke="white"/>
        </svg>`;

        wrapper.append(imgWrap, details, removeIcon);

        // insert before the placeholder so it takes its spot
        ph.insertAdjacentElement('beforebegin', wrapper);
      } else {
        // no item for this slot → show the placeholder
        ph.style.display = '';
      }
    });

    // 4) toggle Add To Cart
    const totalQty = this.selectedItems.reduce((sum, i) => sum + i.quantity, 0);
    if (this.addToCartButton) {
      this.addToCartButton.disabled = totalQty < totalSlots;
      if (this.offerInCart) {
        this.addToCartButton.disabled = true;
        this.addToCartButton.textContent = 'Offer Already in Cart';
      }
    }
  }

  async onAddToCartClick(event) {
    event.preventDefault();

    if (!window.__abc?.addToCart) {
      console.warn('addToCart helper not found');
      return;
    }
    const itemProperties = {
      _offer: this.offerString,
    };

    const payload = this.selectedItems.map((item) => ({
      id: item.variantId,
      quantity: item.quantity,
      properties: itemProperties,
    }));

    if (this.offerVersion !== 'feb2026') {
      const freeGiftPayload = {
        id: this.freeGiftVariantId,
        quantity: 1,
        properties: itemProperties,
      };
      payload.push(freeGiftPayload);
    }

    try {
      await window.__abc.addToCart(payload);

      this.dispatchEvent(
        new CustomEvent('welcome-offer-add-to-cart', {
          bubbles: true,
          composed: true,
        })
      );

      // Close the panel with a small delay to ensure cart drawer opens properly
      const panel = this.closest('welcome-offer-panel');
      if (panel) {
        // Add a small delay to ensure the cart drawer has time to open
        setTimeout(() => {
          panel.close();
        }, 100);
      }
    } catch (err) {
      console.error('Error adding bundle to cart:', err);
    }
  }
  onRemoveClick(event) {
    const btn = event.target.closest('[data-action="remove"]');
    if (!btn) return;
    const productId = btn.getAttribute('data-product-id');
    const variantId = btn.getAttribute('data-variant-id');
    this.dispatchEvent(
      new CustomEvent('welcome-offer-remove-item', {
        detail: { productId, variantId },
        bubbles: true,
        composed: true,
      })
    );
  }
}

customElements.define('welcome-offer-builder-footer', WelcomeOfferBuilderFooter);
